import {
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Stack,
  Button,
  ModalFooter,
} from "@chakra-ui/react"

function SimulationModal({
  isOpen,
  handleRunSecurityChecks,
  handleSkipSecurityChecks,
}: {
  isOpen: boolean
  handleRunSecurityChecks: () => void
  handleSkipSecurityChecks: () => void
}) {
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={() => handleSkipSecurityChecks()}
    >
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent maxWidth={460} top={{ base: "unset", lg: "120px" }}>
        <ModalHeader
          borderBottomColor="gray.100"
          borderBottomWidth={1}
          p={4}
          textStyle="h5"
        >
          Run a simulation?
        </ModalHeader>
        <ModalBody
          borderBottomColor="gray.100"
          borderBottomWidth={1}
          px={4}
          py={4}
        >
          <Stack spacing={4}>
            <Text>
              Simulating a proposal can help check for potential threats and
              mistakes.
            </Text>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Stack direction="row" justifyContent="flex-end" spacing={4}>
            <Button
              colorScheme="gray"
              variant="outline"
              onClick={handleSkipSecurityChecks}
            >
              Skip
            </Button>
            <Button variant="primary" onClick={handleRunSecurityChecks}>
              Run Simulation
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default SimulationModal
